var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-sidebar',{attrs:{"backdrop":"","id":'PackageInfo',"right":"","bg-variant":"grey","shadow":true}},[_c('div',{staticClass:"tab-pane active p-20"},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.imagePath}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }